<template>
    <form @submit.prevent="handleSubmit" class="form-container admin-search-form" data-cy="admin-search-container">
        <p class="text-center text-default-red p-2" v-if="validation.message">
            {{ validation.message }}
        </p>

        <div class="form-section">
            <div class="section-body fields">
                <div class="flex flex-wrap w-full">
                    <div
                        class="input-container px-2 mb-2 md:w-1/3"
                        data-cy="claims-search-association-field"
                        v-if="section_type == 'site_admin'"
                    >
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.association') }}</ui-label>
                        <ui-select
                            v-model="v$.search_form.association_id.$model"
                            :allow-clear="true"
                            :searchable="true"
                            :options="association_list"
                        />
                        <validation-errors :errors="validation.errors.association_id" v-if="validation.errors" />
                    </div>
                    <div
                        class="input-container px-2 mb-2"
                        :class="{ 'md:w-1/3': section_type == 'site_admin', 'md:w-1/2': section_type == 'association' }"
                        data-cy="claims-search-insurer-field"
                    >
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.insurer') }}</ui-label>
                        <ui-select
                            v-model="v$.search_form.company_id.$model"
                            :allow-clear="true"
                            :searchable="true"
                            :options="companies"
                        />
                        <validation-errors :errors="validation.errors.company_id" v-if="validation.errors" />
                    </div>
                    <div
                        class="input-container px-2 mb-2"
                        :class="{ 'md:w-1/6': section_type == 'site_admin', 'md:w-1/4': section_type == 'association' }"
                        data-cy="claims-search-claim-no-field"
                    >
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.claim_no') }}</ui-label>
                        <ui-input v-model="v$.search_form.claim_no.$model" />
                        <validation-errors :errors="validation.errors.claim_no" v-if="validation.errors" />
                    </div>
                    <div
                        class="input-container px-2 mb-2"
                        :class="{ 'md:w-1/6': section_type == 'site_admin', 'md:w-1/4': section_type == 'association' }"
                        data-cy="claims-search-policy-no-field"
                    >
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.policy_no') }}</ui-label>
                        <ui-input v-model="v$.search_form.policy_no.$model" />
                        <validation-errors :errors="validation.errors.policy_no" v-if="validation.errors" />
                    </div>
                    <div class="input-container px-2 mb-2 md:w-2/5" data-cy="claims-search-name-field">
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.name') }}</ui-label>
                        <ui-input v-model="v$.search_form.name.$model" />
                        <validation-errors :errors="validation.errors.name" v-if="validation.errors" />
                    </div>
                    <div class="input-container px-2 mb-2 md:w-1/5" data-cy="claims-search-nid-field">
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.national_id') }}</ui-label>
                        <ui-input v-model="v$.search_form.national_id.$model" />
                        <validation-errors :errors="validation.errors.national_id" v-if="validation.errors" />
                    </div>
                    <div class="input-container px-2 mb-2 md:w-1/5" data-cy="claims-search-driver-id-field">
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.driver_lic_no') }}</ui-label>
                        <ui-input v-model="v$.search_form.driver_lic_no.$model" />
                        <validation-errors :errors="validation.errors.driver_lic_no" v-if="validation.errors" />
                    </div>
                    <div class="input-container px-2 mb-2 md:w-1/5" data-cy="claims-search-claim-year-field">
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.claim_year') }}</ui-label>
                        <ui-select
                            v-model="v$.search_form.claim_year.$model"
                            :allow-clear="true"
                            :searchable="true"
                            :options="years"
                        />
                        <validation-errors :errors="validation.errors.claim_year" v-if="validation.errors" />
                    </div>
                    <div class="input-container px-2 mb-2 md:w-1/4" data-cy="claims-search-reg-no-field">
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.reg_no') }}</ui-label>
                        <ui-input v-model="v$.search_form.reg_no.$model" />
                        <validation-errors :errors="validation.errors.reg_no" v-if="validation.errors" />
                    </div>
                    <div class="input-container px-2 mb-2 md:w-1/4" data-cy="claims-search-chassis-no-field">
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.chassis_no') }}</ui-label>
                        <ui-input v-model="v$.search_form.chassis_no.$model" />
                        <validation-errors :errors="validation.errors.chassis_no" v-if="validation.errors" />
                    </div>
                    <div class="input-container px-2 mb-2 md:w-1/4" data-cy="claims-search-engine-no-field">
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.engine_no') }}</ui-label>
                        <ui-input v-model="v$.search_form.engine_no.$model" />
                        <validation-errors :errors="validation.errors.engine_no" v-if="validation.errors" />
                    </div>
                    <div class="input-container px-2 mb-2 md:w-1/4" data-cy="claims-search-risk-type-field">
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.risk_type') }}</ui-label>
                        <ui-input v-model="v$.search_form.risk_type.$model" />
                        <validation-errors :errors="validation.errors.risk_type" v-if="validation.errors" />
                    </div>
                    <div
                        class="input-container px-2 mb-2 md:w-1/3 2xl:w-1/5"
                        data-cy="claims-search-class-of-business-field"
                    >
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.class_of_business') }}</ui-label>
                        <ui-select
                            v-model="v$.search_form.class_of_business.$model"
                            :allow-clear="true"
                            :searchable="true"
                            :options="class_of_business_list"
                        />
                        <validation-errors :errors="validation.errors.class_of_business" v-if="validation.errors" />
                    </div>
                    <div
                        class="input-container px-2 mb-2 md:w-1/3 2xl:w-1/5"
                        data-cy="claims-search-theft-related-field"
                    >
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.theft_related') }}</ui-label>
                        <ui-select
                            v-model="v$.search_form.theft_related.$model"
                            :allow-clear="true"
                            :searchable="true"
                            :options="theft_related_list"
                        />
                        <validation-errors :errors="validation.errors.theft_related" v-if="validation.errors" />
                    </div>
                    <div
                        class="input-container px-2 mb-2 md:w-1/3 2xl:w-1/5"
                        data-cy="claims-search-claim-status-field"
                    >
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.claim_status') }}</ui-label>
                        <ui-select
                            v-model="v$.search_form.claim_status.$model"
                            :allow-clear="true"
                            :searchable="true"
                            :options="claim_status_list"
                        />
                        <validation-errors :errors="validation.errors.claim_status" v-if="validation.errors" />
                    </div>
                    <div class="input-container px-2 mb-2 md:w-1/2 2xl:w-1/5" data-cy="claims-search-loss-date-field">
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.loss_date_range') }}</ui-label>
                        <ui-date-range-picker-double v-model="v$.search_form.loss_date_range.$model" />
                        <validation-errors :errors="validation.errors.loss_date_range" v-if="validation.errors" />
                    </div>
                    <div
                        class="input-container px-2 mb-2 md:w-1/2 2xl:w-1/5"
                        data-cy="claims-search-imported-date-field"
                    >
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.date_imported_range') }}</ui-label>
                        <ui-date-range-picker-double v-model="v$.search_form.date_imported_range.$model" />
                        <validation-errors :errors="validation.errors.date_imported_range" v-if="validation.errors" />
                    </div>
                    <div class="input-container px-2 mb-2 md:w-1/3 2xl:w-1/5" data-cy="claims-search-file-source-field">
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.file_source') }}</ui-label>
                        <ui-input v-model="v$.search_form.file_source.$model" />
                        <validation-errors :errors="validation.errors.file_source" v-if="validation.errors" />
                    </div>
                    <div class="input-container px-2 mb-2 md:w-1/3" data-cy="claims-search-location-field">
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.risk_location') }}</ui-label>
                        <ui-input v-model="v$.search_form.risk_location.$model" />
                        <validation-errors :errors="validation.errors.risk_location" v-if="validation.errors" />
                    </div>
                    <div class="input-container px-2 mb-2 md:w-1/3" data-cy="claims-search-cause-of-loss-field">
                        <ui-label>{{ $t('claims.search_form.admin_input_fields.cause_of_loss') }}</ui-label>
                        <ui-input v-model="v$.search_form.cause_of_loss.$model" />
                        <validation-errors :errors="validation.errors.cause_of_loss" v-if="validation.errors" />
                    </div>
                </div>
            </div>
            <div class="section-body search-buttons border-t">
                <div class="flex w-full justify-between">
                    <div></div>
                    <div>
                        <a-button data-cy="button-cancel" @click="handleClear" class="mx-2" :disabled="processing">
                            {{ $t('claims.search_form.buttons.clear') }}
                        </a-button>
                        <ui-submit-button class="mx-2" data-cy="button-find" :disabled="processing">
                            <span v-if="!processing">{{ $t('claims.search_form.buttons.find') }}</span>
                            <span v-else>{{ $t('claims.search_form.buttons.finding') }}</span>
                        </ui-submit-button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import UiDateRangePickerDouble from '@/components/ui/DateRangePickerDouble.vue';
import UiInput from '@/components/ui/Input.vue';
import UiLabel from '@/components/ui/Label.vue';
import UiSelect from '@/components/ui/Select.vue';
import UiSubmitButton from '@/components/ui/SubmitButton.vue';

import ValidationErrors from '@/components/ui/ValidationErrors.vue';

import { useVuelidate } from '@vuelidate/core';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        UiDateRangePickerDouble,
        UiInput,
        UiLabel,
        UiSelect,
        UiSubmitButton,
        ValidationErrors,
    },
    data() {
        return {
            association_list: [],
            company_list: [],
            class_of_business_list: [],
            theft_related_list: [],
            claim_status_list: [],
        };
    },
    validations: {
        search_form: {
            association_id: {},
            company_id: {},
            claim_no: {},
            policy_no: {},
            name: {},
            national_id: {},
            driver_lic_no: {},
            claim_year: {},
            reg_no: {},
            chassis_no: {},
            engine_no: {},
            risk_type: {},
            class_of_business: {},
            theft_related: {},
            claim_status: {},
            risk_location: {},
            cause_of_loss: {},
            loss_date_range: {},
            date_imported_range: {},
            file_source: {},
        },
    },
    props: {
        section_type: {
            type: String,
            default: '',
        },
        processing: {
            type: Boolean,
            default: false,
        },
        search_form: {
            type: Object,
            default: {},
        },
        validation: Object,
    },
    mounted() {
        this.fetch();
    },
    computed: {
        companies() {
            let company_filter = [];

            if (this.search_form.association_id != null && this.search_form.association_id != '') {
                this.company_list.forEach((record) => {
                    if (this.search_form.association_id == record.association_id) {
                        company_filter.push({
                            text: record.company_name,
                            value: record.company_id,
                        });
                    }
                });

                let match = false;

                if (this.search_form.company_id != null && this.search_form.company_id != '') {
                    company_filter.forEach((record) => {
                        if (this.search_form.company_id == record.value) {
                            match = true;
                        }
                    });
                }

                if (!match) {
                    this.search_form.company_id = null;
                }
            } else {
                this.company_list.forEach((record) => {
                    company_filter.push({
                        text: record.company_name,
                        value: record.company_id,
                    });
                });
            }

            return company_filter;
        },
        years() {
            var max = new Date().getFullYear();
            var min = max - 100;
            var years = [];

            for (var year = max; year >= min; year--) {
                years.push({
                    text: year,
                    value: year,
                });
            }
            return years;
        },
    },
    methods: {
        fetch() {
            let urls = [
                this.$http.get('/api/listmanager/category/class_of_business'),
                this.$http.get('/api/listmanager/category/theft_related'),
                this.$http.get('/api/listmanager/category/claim_status'),
            ];

            if (this.section_type == 'site_admin') {
                urls.push(this.$http.get('/api/admin/list-companies-by-associations'));
                urls.push(this.$http.get('/api/admin/list-associations'));
            }

            if (this.section_type == 'association') {
                urls.push(
                    this.$http.get('/api/admin/list-companies', {
                        params: {
                            association_id: this.$store.getters['user/currentAssociationId'],
                        },
                    }),
                );
            }

            this.$http.all(urls).then(
                this.$http.spread((class_of_business, theft_related, claim_status, companies, associations) => {
                    this.class_of_business_list = [];
                    this.theft_related_list = [];
                    this.claim_status_list = [];
                    this.company_list = [];
                    this.association_list = [];

                    class_of_business.data.data.forEach((record) => {
                        let if_found = this.class_of_business_list.find((item) => item.text === record.value);

                        if (if_found === undefined) {
                            this.class_of_business_list.push({
                                text: record.value,
                                value: record.value,
                            });
                        }
                    });

                    theft_related.data.data.forEach((record) => {
                        this.theft_related_list.push({
                            text: record.item,
                            value: record.value,
                        });
                    });

                    claim_status.data.data.forEach((record) => {
                        this.claim_status_list.push({
                            text: record.item,
                            value: record.value,
                        });
                    });

                    this.company_list = companies.data.data;

                    if (associations !== undefined) {
                        associations.data.data.forEach((record) => {
                            this.association_list.push({
                                text: record.name,
                                value: record.id,
                            });
                        });
                    }
                }),
            );
        },
        handleClear() {
            this.$emit('clear');
        },
        handleSubmit() {
            this.$emit('formSubmit');
        },
    },
};
</script>
